<div class="peic-dialog">

  <button type="button" class="peic-dialog__close" (click)="goBack()" aria-label="Close">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="peic-dialog__icon">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2L1 21h22L12 2z" fill="#FF7D00" stroke="#FF7D00" stroke-width="1" stroke-linejoin="round"/>
      <path d="M12 9v5" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
      <circle cx="12" cy="17.5" r="1.25" fill="#fff"/>
    </svg>
  </div>

  <p class="peic-dialog__message">{{ data.message }}</p>

  <div class="peic-dialog__divider"></div>

  <div class="peic-dialog__actions">
    <button type="button" class="peic-dialog__btn peic-dialog__btn--secondary" (click)="goBack()">Go back</button>
    <button type="button" class="peic-dialog__btn peic-dialog__btn--primary" (click)="submitAnyway()">Submit anyway</button>
  </div>

</div>
